var createStylesheet = function(chunkId, fullhref, resolve, reject) {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = function(event) {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = function(href, fullhref) {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = function(chunkId) {
	return new Promise(function(resolve, reject) {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"kfprocess": 0
};

__webpack_require__.f.miniCss = function(chunkId, promises) {
	var cssChunks = {"src_form_formmodal_Duplicate_svg-src_form_formmodal_backbutton_svg-src_form_formmodal_print_P-65303a":1,"src_form_formmodal_index_jsx-src_form_formmodal_form_css":1,"src_process_topnav_jsx":1,"src_studio_workflow_workflow_component_js-webpack_sharing_consume_default_prop-types_prop-typ-37771d":1,"src_studio_icons_close_svg-src_studio_cleanup_js-src_studio_constants_js-src_studio_studio_se-710145":1,"common_src_component_treestructure_tree_structure_css-src_studio_helpsection_helpsection_css--22c3e7":1,"src_studio_flow_lock_jsx":1,"src_dashboard_index_jsx":1,"src_settings_general_settings_jsx":1,"src_settings_emailcard_setting_jsx":1,"common_src_constant_js-common_src_stores_process_js-src_settings_settings_css":1,"src_settings_sequencenumber_jsx":1,"src_settings_publicform_jsx":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_asyncToGenerato-e6c08f":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_asyncToGenerato-48d00e":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_asyncToGenerato-8fcc41":1,"node_modules_pnpm_babel_runtime_7_12_1_node_modules_babel_runtime_helpers_esm_asyncToGenerato-3211c3":1,"src_component_importcsv_index_jsx":1,"src_apps_index_jsx-node_modules_pnpm_zustand_4_0_0_immer_9_0_6_react_18_2_0_node_modules_zust-91767b":1,"src_myitems_myitemsandmytasks_css-_f5180":1,"src_myitems_myitemsandmytasks_css-_f5181":1,"src_settings_index_jsx-src_settings_settings_css":1,"src_metrics_index_jsx-src_component_sort_sort_css-src_metrics_components_grid_header_grid_hea-74b0d1":1,"src_processsharesettings_index_jsx":1,"src_report_report_home_jsx":1,"src_audit_audit_css":1,"src_audit_index_jsx":1,"src_metrics_status_data_jsx":1,"src_metrics_metrics_reports_jsx":1,"src_documenttemplates_index_jsx":1,"src_duplicate_index_jsx":1,"src_studio_permission_index_jsx-_6c7a0":1,"src_studio_preview_preview_component_jsx-src_form_formmodal_form_css":1,"src_form_progressmodal_progress_modal_jsx":1,"src_report_reportlist_index_jsx":1,"src_documenttemplates_documents_list_jsx":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(function() {
			installedCssChunks[chunkId] = 0;
		}, function(e) {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr